"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME_NUMBERS = exports.getBirthNumber = exports.isImplementedNumerology = exports.implementedNumerologies = exports.DEFAULT_NUMEROLOGY = void 0;
exports.reduceToSingleDigit = reduceToSingleDigit;
exports.getNameNumber = getNameNumber;
const Chaldean_1 = require("./Chaldean");
const Enkanitham_1 = require("./Enkanitham");
const Pythagorean_1 = require("./Pythagorean");
exports.DEFAULT_NUMEROLOGY = 'enkanitham';
/**
 * Methods are registered as they are implemented; `getStateFromParams` only
 * accepts the ones listed, so an unimplemented method cannot reach a name.
 */
const nameValueByNumerology = {
    enkanitham: Enkanitham_1.getNameNumberEnkanitham,
    chaldean: Chaldean_1.getNameNumberChaldean,
    pythagorean: Pythagorean_1.getNameNumberPythagorean,
};
exports.implementedNumerologies = Object.keys(nameValueByNumerology);
const isImplementedNumerology = (value) => exports.implementedNumerologies.includes(value);
exports.isImplementedNumerology = isImplementedNumerology;
function reduceToSingleDigit(value) {
    let result = Math.abs(Math.trunc(value));
    while (result > 9) {
        let sum = 0;
        for (let rest = result; rest > 0; rest = Math.floor(rest / 10)) {
            sum += rest % 10;
        }
        result = sum;
    }
    return result;
}
/**
 * Null when the method assigns the name no value. Each method reads one script -
 * Enkanitham Tamil, the other two Latin - so which names are valued depends on
 * the method as much as on the name.
 */
function getNameNumber(name, numerology = exports.DEFAULT_NUMEROLOGY) {
    const value = nameValueByNumerology[numerology];
    if (!value) {
        return null;
    }
    const total = value(name);
    return total === null
        ? null
        : { total, number: reduceToSingleDigit(total) };
}
// Every method reads the birth number the same way, so it is not pluggable.
const getBirthNumber = (dayOfMonth) => reduceToSingleDigit(dayOfMonth);
exports.getBirthNumber = getBirthNumber;
exports.NAME_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9];
//# sourceMappingURL=Numbers.js.map